/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Dostęp do zasobów i materiałów wsparcia dla CamAPS FX i CamAPS Liberty®.',
    keywords: 'biblioteka camaps, camaps fx, camaps liberty, zasoby wsparcia, zarządzanie cukrzycą',
    localeMeta: 'pl_pl',

    bannerTitle: 'Wsparcie poza liczbami',
    bannerSubtitle: 'z CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Po aktywacji użytkownicy nie będą musieli liczyć węglowodanów i podawać bolusa przed posiłkiem.',
    bannerCompatibility: 'Zgodny z Androidem i iOS',
    
    announcementText: 'Wkrótce dla użytkowników myLoop AID*',
    announcementDisclaimer: '* W zależności od lokalnych zatwierdzeń rynkowych i dostępności',

    introTitle: 'Pierwsza w pełni zamknięta pętla. Gdy jej potrzebujesz.',
    introDescription: 'Po aktywacji użytkownicy nie będą musieli liczyć węglowodanów i podawać przedposiłkowego bolusa insuliny.',
    introSubtext: 'Dostępne w systemach operacyjnych Android i Apple',

    howItWorksTitle: 'Jak to działa?',
    howItWorksDescription: 'Napędzany bardziej proaktywną wersją algorytmu CamAPS. CamAPS Liberty przewiduje i reaguje na zmiany glukozy, zachowując ustalone granice bezpieczeństwa.',
    
    step1Title: 'KROK 1',
    step1Description: 'Z ekranu głównego przejdź do menu ustawień.',
    step2Title: 'KROK 2',
    step2Description: 'Przewiń w dół i dotknij przełącznika, aby aktywować.',
    step3Title: 'KROK 3',
    step3Description: 'Przy pierwszym użyciu musisz obejrzeć nasz film wyjaśniający o CamAPS Liberty.',
    step4Title: 'KROK 4',
    step4Description: 'Potwierdź, że nie masz mniej niż 13 lat i nie jesteś w ciąży.',
    step5Title: 'KROK 5',
    step5Description: 'Dotknij ponownie przełącznika, aby aktywować.',
    step6Title: 'KROK 6',
    step6Description: "Wszystko gotowe. Karta CamAPS Liberty pojawi się na ekranie głównym<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Działa tylko gdy włączony jest \"Auto mode\"",

    eligibilityTitle: 'Kto może używać CamAPS Liberty?',
    eligibilityCriterion1: 'Istniejący użytkownicy z cukrzycą typu 1',
    eligibilityCriterion2: '13 lat i starsi',
    eligibilityCriterion3: 'W ciąży',
    parentsCarersTitle: 'A co z rodzicami i opiekunami?',
    parentsCarersBlockTitle: 'Funkcja "Blokuj":',
    parentsCarersBlockDescription: 'Aby zapobiec przypadkowemu użyciu',
    parentsCarersRemoteTitle: 'Zdalne monitorowanie:',
    parentsCarersRemoteDescription: 'Companion, Glooko® i 2-tygodniowe raporty PDF CamAPS',

    imageOverlayText: 'Zaprojektowany, aby działać obok Twojego obecnego planu zarządzania cukrzycą; nie zastępować go.',
    
    usingTitle: 'Używanie CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty została zaprojektowana tak, aby wyeliminować konieczność rutynowego podawania bolusów do posiłków. Nie zastępuje pozostałych elementów planu leczenia cukrzycy użytkownika, w tym regularnych konsultacji z zespołem diabetologicznym.',
    
    usingLibertyTitle: 'Obejrzyj i poznaj CamAPS Liberty',
    usingLibertyDescription: 'Przeglądaj filmy, aby dowiedzieć się więcej o CamAPS Liberty i jak zacząć.',
    // latestVideoLabel removed
    moreVideosLabel: 'Więcej filmów',
    factsheetDownloadText: 'Ulotka informacyjna CamAPS Liberty (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_pl.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Pierwsze kroki',
        description: 'Candice Ward wyjaśnia, jak skonfigurować i zacząć korzystać z CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/_d6fwzT0jSc',
            title: 'Wskazówki: CamAPS Liberty',
            duration: '02:11',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Wprowadzenie do CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'To uczucie fully closed-loop',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/cPjMSqLUgVs',
            title: 'Funkcja CamAPS Liberty',
            duration: '03:27',
        }
    ],
    
    whatHappensNextTitle: 'Co dalej?',
    whatHappensNextText: 'Przeprowadzimy pilotaż w jednym rynku w nadchodzących miesiącach. Zostań z nami, aby uzyskać więcej szczegółów.',
};

